import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SupplierResponse } from '../Models/Supplier';
import { DynamicFieldRequest } from '../Models/FieldEntry';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  private readonly apiUrl = environment.apiUrl; // from environment file
  //private readonly apiUrl = 'http://localhost:7109/api/suppliers'; /*For Localhost environment debug*/
  constructor(private readonly http: HttpClient, private readonly authService: AuthService) { }

  getSuppliers(model: DynamicFieldRequest): Observable<SupplierResponse> {
    return from(this.authService.acquireAccessToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
          'x-functions-key': environment.functionKey
        });

        return this.http.post<SupplierResponse>(this.apiUrl, model, { headers });
      })
    );
  }
}
